// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"1bed6fdf","107":"e9d1c409","335":"6d7af663","457":"49b8b51d","521":"441fd455"}[chunkId] + ".chunk.js";
};